import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import AIChat from "./components/AIChat";
import FloatingCart from "./components/FloatingCart";
import PromoMarquee from "./components/PromoMarquee";
import CountdownStrip from "./components/CountdownStrip";
import ExitIntentPopup from "./components/ExitIntentPopup";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Promociones from "./pages/Promociones";
import Contacto from "./pages/Contacto";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <CartProvider>
                    <div className="App min-h-screen flex flex-col bg-background">
                        <CountdownStrip />
                        <PromoMarquee />
                        <Header />
                        <main className="flex-1">
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/productos" element={<Products />} />
                                <Route path="/promociones" element={<Promociones />} />
                                <Route path="/contacto" element={<Contacto />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/registro" element={<Register />} />
                                <Route
                                    path="/perfil"
                                    element={
                                        <ProtectedRoute>
                                            <Profile />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/admin"
                                    element={
                                        <ProtectedRoute adminOnly>
                                            <Admin />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route path="*" element={<Home />} />
                            </Routes>
                        </main>
                        <Footer />
                        <CartDrawer />
                        <FloatingCart />
                        <AIChat />
                        <ExitIntentPopup />
                        <Toaster
                            richColors={false}
                            position="top-right"
                            closeButton
                            toastOptions={{
                                style: { background: "#FFFFFF", color: "#3E2723", border: "1px solid #FFD166" },
                            }}
                        />
                    </div>
                </CartProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
